// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title = "ERP Software, POS System & Web Development Company in Pakistan | MZR Software",
  description = "MZR Software provides ERP software, POS systems, inventory management and custom web development services in Pakistan.",
  image,
  url = "https://www.mzrsoftware.com/",
}) => {
  const baseUrl = "https://www.mzrsoftware.com";

  // ✅ Always use absolute URL for images
  const defaultImage = `${baseUrl}/img/mzr-software-erp-pos-preview.png`;

  // ✅ Clean keywords (no spam)
  const keywords =
    "ERP software Pakistan, POS system Pakistan, inventory management system, web development company Pakistan, custom software development, SaaS solutions, .NET development";

  // ✅ Ensure full URL
  const fullUrl = url.startsWith("http") ? url : baseUrl + url;

  const fullImage = image
    ? image.startsWith("http")
      ? image
      : baseUrl + image
    : defaultImage;

  // ✅ Organization Schema
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "MZR Software",
    url: baseUrl,
    logo: `${baseUrl}/logo.png`,
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+92-335-1206586",
      contactType: "customer support",
      areaServed: "PK",
    },
    sameAs: [
      "https://www.facebook.com/MZRSoftware",
      "https://www.linkedin.com/company/mzr-software",
    ],
  };

  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Basic SEO */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="MZR Software" />
      <meta name="robots" content="index, follow" />

      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MZR Software" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Schema */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
